export default __webpack_public_path__ + "static/media/Online.dc6645a6.svg";